if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.variant = null;
        this.source = null;
        this.variantInventory = null;
        this.isPreorder = false;
        this.isSoldOut = false;
        this.productShippingInfo = null;

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.onVariantChange.bind(this),
        );
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll('.scroll-trigger')
            .forEach((element) => element.classList.add('scroll-trigger--cancel')),
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      onVariantChange(event) {
        this.variant = event.detail.variant;
        this.source = event.detail.source;

        if (!this.source) return;
        if (!this.variant) {
          this.source.setUnavailable();
          return;
        }
        this.isSoldOut = !this.variant.available;
        this.isPreorder = !this.isSoldOut && this.variant.is_preorder;

        const variantRadios = this.querySelector('variant-radios');
        if (this.isSoldOut && !this.isPreorder) {
          this.source.setUnavailable('soldOut');
          this.source.toggleAddButton(true, '', false);
        } else {
          this.source.toggleAddButton(false, '', false);
        }
        if (variantRadios && this.source === variantRadios) {
          this.updateCheckoutLabel();
        }
      }

      updateCheckoutLabel() {
        if (!this.variant) return;

        const labelElement = this.querySelector('.preorder-checkout-label');
        if (!labelElement) return;

        this.productShippingInfo = this.productShippingInfo || this.querySelector('[id^="product-shipping-info-"]');
        const productShippingTime =
          this.variant.availability_text ||
          this.productShippingInfo?.dataset?.productShippingTime ||
          window.sectionSettings?.shippingCheckoutLabel;
        const preorderShippingTime =
          this.variant.availability_text ||
          this.productShippingInfo?.dataset?.preorderShippingTime ||
          window.sectionSettings?.preorderCheckoutLabel;
        const soldOutLabel =
          this.productShippingInfo?.dataset?.soldOutLabel || window.sectionSettings?.soldoutCheckoutLabel;

        if (labelElement) {
          labelElement.textContent = this.isPreorder
            ? preorderShippingTime
            : this.isSoldOut
              ? soldOutLabel
              : productShippingTime;
          labelElement.style.display = 'block';

          const typeInput = this.querySelector('input[name="properties[Type]"]');
          if (this.isPreorder) {
            if (!typeInput) {
              const form = this.querySelector('form[data-type="add-to-cart-form"]');
              if (form) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'properties[Type]';
                input.value = preorderShippingTime;
                form.insertBefore(input, form.firstChild);
              }
            } else {
              typeInput.value = preorderShippingTime;
            }
          } else if (typeInput) {
            typeInput.remove();
          }
        }

        // Delivery Options popup card timelines. The per-service business-day
        // ranges only hold while the variant ships from stock; on a pre-order
        // variant every service waits on the same inbound window, so all three
        // cards show the metafield text verbatim. document-scoped because the
        // modal-dialog sits outside <product-info>; no-op on PDPs without it.
        document.querySelectorAll('#PopupModal-Delivery [data-delivery-timeline]').forEach((timeline) => {
          timeline.textContent = this.isPreorder ? preorderShippingTime : timeline.dataset.defaultTimeline;
        });
      }
    },
  );
}
